import api from '@/api/api'

export default {
    async get(resource) {
        const resp = await api.get(`/api/configuration/${resource}`)

        return resp.data
    },
}
